import { IvideonService } from "~/entity/Ivideon/api/service";

export const useIvideon = () => {
  const ivideonGetToken = IvideonService.GET.getToken;
  const ivideonSubscriptions = IvideonService.GET.getSubscriptions;
  const ivideonCreateToken = IvideonService.POST.createToken;
  const ivideonSynchGroupDealer = IvideonService.GET.synchGroupDealer;
  const sendAction = IvideonService.POST.sendAction;
  const getIvideonDealerDocs = IvideonService.GET.getIvideonDealerDocs;
  const getIvideonDealers = IvideonService.GET.getIvideonDealers;
  const getIvideonLicensesReport = IvideonService.GET.getIvideonLicensesReport;
  const acceptAct = IvideonService.PUT.acceptAct;
  const deacceptAct = IvideonService.PUT.deacceptAct;
  const acceptCamera = IvideonService.PUT.acceptCamera;
  const getIvideonHistory = IvideonService.GET.getIvideonHistory;
  const getIvideonHistoryCameras = IvideonService.GET.getIvideonHistoryCameras;
  const getIvideonHistoryActs = IvideonService.GET.getIvideonHistoryActs;
  const getAvailabilityReport = IvideonService.GET.getAvailabilityReport;
  const getDealersIvideon = IvideonService.GET.getDealersIvideon;
  const getWorkOrderReport = IvideonService.POST.getWorkOrderReport;
  const getEmployeesReport = IvideonService.POST.getEmployeesReport;
  const getIvideonReport = IvideonService.GET.getIvideonReport;
  const getDealerOfflineReport = IvideonService.GET.getDealerOfflineReport;
  const ivideonFaceAnalytics = IvideonService.POST.getAnalyticsFace;
  const ivideonVehicleAnalytics = IvideonService.POST.getAnalyticsVehicle;
  const getSubscriptionsList = IvideonService.GET.getSubscriptionsList;
  const getAnalyticaReport = IvideonService.POST.getAnalyticaReport;
  const getTariffs = IvideonService.GET.getTariffs;
  const createTariff = IvideonService.POST.createTariff;
  const updateTariff = IvideonService.PUT.updateTariff;
  const deleteTariff = IvideonService.DELETE.deleteTariff;
  const cameraCheckStatus = IvideonService.GET.cameraCheckStatus;

  return {
    ivideonGetToken,
    ivideonCreateToken,
    ivideonSynchGroupDealer,
    sendAction,
    getIvideonDealerDocs,
    getIvideonDealers,
    getIvideonLicensesReport,
    acceptAct,
    deacceptAct,
    acceptCamera,
    getIvideonHistory,
    getIvideonHistoryCameras,
    getIvideonHistoryActs,
    getAvailabilityReport,
    getDealersIvideon,
    getWorkOrderReport,
    getEmployeesReport,
    getIvideonReport,
    getDealerOfflineReport,
    ivideonFaceAnalytics,
    ivideonVehicleAnalytics,
    ivideonSubscriptions,
    getSubscriptionsList,
    getAnalyticaReport,
    getTariffs,
    createTariff,
    updateTariff,
    deleteTariff,
    cameraCheckStatus,
  };
};
